import { Bolt, Build, Chat, Search, Warning } from "@mui/icons-material";
import { Box, SxProps, Theme } from "@mui/material";
import { SectionContainer } from "src/modules/SectionContainer/SectionContainer";
import { SectionTitle } from "src/modules/SectionTitle/SectionTitle";
import { SectionSubtitle } from "src/modules/SectionSubtitle/SectionSubtitle";

import { StepTimeline } from "../../../../modules/StepTimeline/StepTimeline";

export const Flow = () => {
  return (
    <SectionContainer>
      <SectionTitle>アラート対応の流れ</SectionTitle>
      <SectionSubtitle>シームレスな対応フローで、問題発生から解決までの時間を最小限に抑制</SectionSubtitle>

      <Box sx={flowContainerSx}>
        <StepTimeline
          steps={[
            {
              icon: <Search sx={{ fontSize: "2rem", color: "#fff" }} />,
              title: "システム監視",
              description: "クライアント側のシステムを常時監視し、異常を検知します。",
              color: "info",
            },
            {
              icon: <Warning sx={{ fontSize: "2rem", color: "#fff" }} />,
              title: "アラート発生",
              description: "システム異常を検知すると、自動的にアラートが発生します。",
              color: "info",
            },
            {
              icon: <Chat sx={{ fontSize: "2rem", color: "#fff" }} />,
              title: "Slack通知",
              description: "アラート情報が Slackに通知され、即時に対応プロセスが開始されます。",
              color: "info",
            },
            {
              icon: <Build sx={{ fontSize: "2rem", color: "#fff" }} />,
              title: "L1エンジニア対応",
              description: "一次対応として L1エンジニアが問題を分析し、可能な対応を行います。",
              color: "info",
            },
            {
              icon: <Bolt sx={{ fontSize: "2rem", color: "#fff" }} />,
              title: "L2エンジニア対応",
              description: "複雑な問題はハイエンドな L2エンジニアがエスカレーションを受け対応します。",
              color: "info",
            },
          ]}
        />
      </Box>
    </SectionContainer>
  );
};

const flowContainerSx: SxProps<Theme> = {
  background: "#fff",
  padding: "40px 30px",
  borderRadius: "20px",
  boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
  transition: "transform 0.3s ease, box-shadow 0.3s ease",
  border: "3px solid transparent",
  position: "relative",
};
